/**
 * @file footer
 * @author 陈恩浩
 */

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { changePopup, changeMenu } from 'src/redux/basicInfo'
import { connect } from 'react-redux'

import './index.scss'
@connect((state) => state, { changePopup, changeMenu })

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  handleClear = () => {
    this.props.changeMenu('')
  }

  componentDidMount() { }

  render() {
    return (
      <div className="footer">
        <div className="inner">
          <div className="map-detail-wrap">
            <div className="map-detail">
              <div className="map-img"></div>
              <div className="map-text">
                电话：+86-571-88162929 &nbsp;&nbsp;邮箱：contact@ihatoo.com
                &nbsp;&nbsp;地址：浙江省杭州市萧山区宁围街道国泰科技大厦A座1001室
              </div>
            </div>
            <div className="map-filing">
              IHATOO©2020哈兔中文网络科技有限公司-浙ICP备15040512号
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
